import { createQuery } from 'QueryKit'
import { getFilterMetaData } from 'API/definitions/iris/filter'
import { computed, watch } from 'vue' // Import watch for debugging
import { useFilterStore } from 'Store/filterStore'

/**
 * A reactive TanStack query hook to fetch filter metadata.
 * It automatically tracks the filter store for changes to the inspection instance
 * and only runs when the filters are ready.
 */
const useFilterMetaDataQuery = () => {
  const filterStore = useFilterStore()

  // Get reactive state directly from the Pinia store.
  const areFiltersReady = computed(() => filterStore.areFiltersReady)
  const inspectionInstanceUuid = computed(() => {
    if (filterStore.filtersModel.inspectionInstance?.length > 0) {
      return filterStore.filtersModel.inspectionInstance[0]
    }
    return null
  })

  const generatedQueryHook = createQuery<any, any, Error>({
    primaryKey: ['filter_meta-data', inspectionInstanceUuid],

    queryFn: () => {
      const inspectionInstance = inspectionInstanceUuid.value
      return getFilterMetaData({ inspectionInstance: inspectionInstance as string | undefined })
    },

    options: {
      keepPreviousData: true,
      enabled: areFiltersReady,
    },
  })

  return generatedQueryHook()
}

export { useFilterMetaDataQuery }
